
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import MainMenu from '@/components/MainMenu/MainMenu.vue';

@Component({
  components: { MainMenu },
})
export default class App extends Vue {
  @Getter('user/authenticated') authenticated!: boolean;
}
